var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.vloading,
          expression: "vloading"
        }
      ],
      staticClass: "study2022-5-26"
    },
    [
      _vm.listItem && _vm.listItem.id && _vm.iframeUrl
        ? _c("JumpTemplate", {
            attrs: {
              childrenIframeUrl: _vm.childrenIframeUrl,
              activeOne: _vm.listItem,
              optObject: _vm.optObject,
              platformName: _vm.buttonShowArr,
              isBtn: _vm.isBtn,
              type: _vm.type,
              catalogId: _vm.catalogId,
              templateCode: _vm.templateCode
            },
            on: { insertDirectory: _vm.insertDirectory },
            model: {
              value: _vm.iframeUrl,
              callback: function($$v) {
                _vm.iframeUrl = $$v
              },
              expression: "iframeUrl"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "course_content" }, [
        _c("div", {
          staticClass: "menu-toggle",
          class: { "menu-open": !_vm.menuFlag },
          on: { click: _vm.toggleMenu }
        }),
        _vm._v(" "),
        _vm.menuFlag
          ? _c("div", { staticClass: "course_left" }, [
              _c("div", { staticClass: "study_zonghe" }, [
                _vm.type == 3 || _vm.type == 7
                  ? _c("div", { staticClass: "left" }, [
                      _c("i"),
                      _vm._v(" "),
                      _c("p", [_vm._v("我的岗位")]),
                      _vm._v(" "),
                      _vm.myStation.length
                        ? _c(
                            "ul",
                            _vm._l(_vm.myStation, function(item, index) {
                              return _c(
                                "li",
                                { key: index, attrs: { title: item.name } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            0
                          )
                        : _c("ul", [_c("li", [_vm._v("暂无岗位")])])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _c(
                    "div",
                    { staticClass: "study_progress_box" },
                    [
                      _c("el-progress", {
                        staticClass: "circle_progress",
                        attrs: {
                          type: "circle",
                          percentage:
                            _vm.percentage > 100 ? 100 : _vm.percentage
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            "progress_text " +
                            (_vm.percentage == 100 ? "percentage" : "")
                        },
                        [_vm._v(_vm._s(Math.ceil(_vm.percentage)) + "%")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "course_tree" },
                [
                  _c("el-tree", {
                    ref: "vuetree",
                    attrs: {
                      data: _vm.catalogData,
                      props: _vm.defaultProps,
                      "node-key": "id",
                      "default-expanded-keys": _vm.expendId,
                      "highlight-current": true
                    },
                    on: { "node-click": _vm.handleNodeClick },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var node = ref.node
                            var data = ref.data
                            return _c(
                              "span",
                              { staticClass: "span-ellipsis" },
                              [
                                _c("span", { attrs: { title: node.label } }, [
                                  _vm._v(_vm._s(node.label))
                                ]),
                                _vm._v(" "),
                                _vm.userType == 2 || _vm.userType == 3
                                  ? [
                                      !data.status || data.lockStatus == 1
                                        ? _c(
                                            "span",
                                            { staticClass: "is_finish" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-lock"
                                              })
                                            ]
                                          )
                                        : [
                                            data.isFinish == 1 &&
                                            data.taskType == 1
                                              ? _c("img", {
                                                  staticClass: "is_finish",
                                                  attrs: { src: _vm.isFinish }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.isFinish == 0 &&
                                            data.taskType == 1
                                              ? _c("img", {
                                                  staticClass: "is_finish",
                                                  attrs: { src: _vm.unFinish }
                                                })
                                              : _vm._e()
                                          ],
                                      _vm._v(" "),
                                      !data.status &&
                                      (_vm.userType == 0 || _vm.userType == 1)
                                        ? [
                                            data.isFinish == 1 &&
                                            data.taskType == 1
                                              ? _c("img", {
                                                  staticClass: "is_finish",
                                                  attrs: { src: _vm.isFinish }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.isFinish == 0 &&
                                            data.taskType == 1
                                              ? _c("img", {
                                                  staticClass: "is_finish",
                                                  attrs: { src: _vm.unFinish }
                                                })
                                              : _vm._e()
                                          ]
                                        : _vm._e()
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userType == 0 || _vm.userType == 1
                                  ? [
                                      data.lockStatus == 1
                                        ? _c(
                                            "span",
                                            { staticClass: "is_finish" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-lock"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.lockStatus == 0
                                        ? [
                                            data.isFinish == 1 &&
                                            data.taskType == 1
                                              ? _c("img", {
                                                  staticClass: "is_finish",
                                                  attrs: { src: _vm.isFinish }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.isFinish == 0 &&
                                            data.taskType == 1
                                              ? _c("img", {
                                                  staticClass: "is_finish",
                                                  attrs: { src: _vm.unFinish }
                                                })
                                              : _vm._e()
                                          ]
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }
                        }
                      ],
                      null,
                      false,
                      3868049647
                    )
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.statusFlag && !_vm.statusLoading
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "course_main"
              },
              [
                !_vm.swiperFlag && _vm.type != 3
                  ? _c("miniSwiper", {
                      on: { getActiveIndex: _vm.getActiveIndex }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.listItem && Object.keys(_vm.listItem).length
                  ? _c(
                      "div",
                      {
                        staticClass: "show_main",
                        style:
                          "height: " +
                          (_vm.type == 3 ||
                          ((_vm.type == 2 || _vm.type == 1) && _vm.swiperFlag)
                            ? _vm.windowHeight - 88
                            : _vm.windowHeight - 120) +
                          "px"
                      },
                      [
                        _c("h2", { staticClass: "title" }, [
                          _vm.listItem.testPaper === null
                            ? _c("span", { staticClass: "task_name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.listItem.resourceType === 3
                                      ? "试题"
                                      : _vm.listItem.name
                                  )
                                )
                              ])
                            : _c("span", { staticClass: "task_name" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.listItem.resourceType === 3
                                        ? "试题"
                                        : _vm.listItem.testPaper
                                        ? _vm.listItem.name +
                                          "(" +
                                          _vm.listItem.testPaper.paperScore +
                                          "分" +
                                          "/" +
                                          _vm.listItem.testPaper.count +
                                          "题" +
                                          ")"
                                        : ""
                                    ) +
                                    "\n          "
                                )
                              ]),
                          _vm._v(" "),
                          _vm.startTest === "answerDetail"
                            ? _c(
                                "span",
                                {
                                  staticClass: "task_name",
                                  staticStyle: { "margin-left": "25px" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.listItem.resourceType === 3
                                        ? ""
                                        : "得分 ："
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.startTest === "answerDetail"
                            ? _c(
                                "span",
                                {
                                  staticClass: "task_name",
                                  staticStyle: { color: "red" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.listItem.resourceType === 3
                                        ? ""
                                        : _vm.score
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.listItem &&
                          _vm.listItem.downloadFlag == 1 &&
                          _vm.listItem.resourceType == 1
                            ? _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.download(_vm.listItem.id)
                                    }
                                  }
                                },
                                [_vm._v("下 载\n          ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.listItem.resourceType === 3 &&
                          (_vm.userType == 0 || _vm.userType == 1) &&
                          _vm.courseType == "3"
                            ? _c(
                                "div",
                                {
                                  staticClass: "is_view_answers",
                                  on: {
                                    click: function($event) {
                                      return _vm.selectViewAnswers(_vm.listItem)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    class: _vm.listItem.show ? "true" : "false"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "padding-left": "3px" } },
                                    [_vm._v("允许查看答案")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.listItem.type == 1
                          ? _c("div", { staticClass: "img_wrap" }, [
                              _c(
                                "div",
                                {
                                  style: {
                                    transform: "scale(1)",
                                    transformOrigin: "top left"
                                  }
                                },
                                [
                                  _c(
                                    "viewer",
                                    {
                                      attrs: {
                                        images: [_vm.listItem.newAttaUrl]
                                      }
                                    },
                                    _vm._l([_vm.listItem.newAttaUrl], function(
                                      src,
                                      i
                                    ) {
                                      return _c("img", {
                                        key: i,
                                        attrs: { src: src }
                                      })
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.listItem.type == 2
                          ? _c(
                              "div",
                              {
                                class:
                                  "pdf_wrap " +
                                  _vm.pdfEnlargStyle +
                                  " " +
                                  _vm.pageStyle,
                                on: { dblclick: _vm.pdfdblclick }
                              },
                              [
                                _c("pdf", {
                                  ref: "pdf",
                                  staticStyle: { width: "99%", margin: "auto" },
                                  attrs: {
                                    src: _vm.listItem.newAttaUrl,
                                    page: _vm.pageNum,
                                    rotate: _vm.pageRotate
                                  },
                                  on: {
                                    progress: function($event) {
                                      _vm.loadedRatio = $event
                                    },
                                    "num-pages": function($event) {
                                      _vm.pageTotalNum = $event
                                    },
                                    "link-clicked": function($event) {
                                      _vm.page = $event
                                    },
                                    loaded: _vm.loadPdfHandler
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-left btn-def btn-pre",
                                  on: {
                                    dblclick: function($event) {
                                      $event.stopPropagation()
                                    },
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.prePage.apply(null, arguments)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-right btn-def btn-next",
                                  on: {
                                    dblclick: function($event) {
                                      $event.stopPropagation()
                                    },
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.nextPage.apply(null, arguments)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "pdfCurrentPage" }, [
                                  _vm._v(
                                    _vm._s(_vm.pageNum) +
                                      "/" +
                                      _vm._s(_vm.pageTotalNum)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "operating_btn" }, [
                                  _c("div", [
                                    _c("i", {
                                      staticClass: "el-icon-refresh-left",
                                      on: {
                                        click: _vm.counterClock,
                                        dblclick: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "el-icon-refresh-right",
                                      on: {
                                        click: _vm.clock,
                                        dblclick: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    })
                                  ])
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.listItem.type == 3
                          ? _c("audio", {
                              ref: "audioC",
                              attrs: {
                                src: _vm.listItem.newAttaUrl,
                                controls: "controls"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.listItem.type == 4
                          ? _c(
                              "video",
                              {
                                ref: "videoC",
                                staticClass: "video-js",
                                style: "height:" + _vm.videoHeight,
                                attrs: {
                                  id: "video1",
                                  controls: "",
                                  controlsList: "nodownload",
                                  preload: "auto",
                                  width: "100%",
                                  "data-setup": '{"example_option":true}'
                                },
                                on: { play: _vm.videoPlay, ended: _vm.endVideo }
                              },
                              [
                                _c("source", {
                                  attrs: {
                                    id: "sourceBox",
                                    src: _vm.listItem.newAttaUrl,
                                    type: "video/mp4"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "vjs-no-js" }, [
                                  _vm._v("不支持播放")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.listItem.type == 5
                          ? _c("div", { staticClass: "zip_wrap" }, [
                              _vm.isZip
                                ? _c("iframe", {
                                    attrs: {
                                      width: "100%",
                                      height: "100%",
                                      src: _vm.listItem.newAttaUrl,
                                      frameborder: "0"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isZip && _vm.listItem.downloadFlag == 1
                                ? _c("div", [
                                    _c("p", [
                                      _vm._v(
                                        "请点击“下载”，下载 “" +
                                          _vm._s(_vm.listItem.name) +
                                          "” 到本地。"
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.listItem.resourceType == 3
                          ? _c("div", { staticClass: "zip_wrap" }, [
                              _c("div", {
                                staticClass: "editorShowArea ql-editor",
                                domProps: {
                                  innerHTML: _vm._s(_vm.listItem.content)
                                }
                              }),
                              _vm._v(" "),
                              _vm.listItem.resourceType == 3
                                ? _c(
                                    "div",
                                    { staticClass: "btn_wrap" },
                                    [
                                      _vm.rolesStatus === 0
                                        ? _c("platform-btn", {
                                            attrs: {
                                              type: _vm.type,
                                              courseId: _vm.courseId,
                                              classId: _vm.classId,
                                              catalogId: _vm.catalogId,
                                              listItem: _vm.listItem,
                                              myStation: _vm.myStation,
                                              buttonShowArr: _vm.buttonShowArr
                                            },
                                            on: {
                                              platformJump: _vm.platformJump
                                            }
                                          })
                                        : _vm.rolesStatus === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#E6A23C" }
                                            },
                                            [_vm._v("此业务非“我的”职责任务")]
                                          )
                                        : _vm.rolesStatus === 2
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#E6A23C" }
                                            },
                                            [_vm._v("该任务无需作答")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.listItem.resourceType == 5
                          ? _c("div", { staticClass: "test_wrap" }, [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.listItem.testPaper.sections,
                                  function(item, key) {
                                    return _c("li", { key: key }, [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            item.sectionAlias ||
                                              item.sectionName
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(item.sectionScore) +
                                            "分 / " +
                                            _vm._s(item.questionCount) +
                                            "题"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.sectionName == "单选题"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("../../../../../../static/images/study/radio.png")
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.sectionName == "多选题"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("../../../../../../static/images/study/checkbox.png")
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.sectionName == "判断题"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("../../../../../../static/images/study/judge.png")
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.sectionName == "实操题"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("../../../../../../static/images/study/operation.png")
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "startPractice_box" }, [
                                _vm.startTest === "answerDetail"
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "bury",
                                            rawName: "v-bury",
                                            value: { start: true },
                                            expression: "{start: true}"
                                          }
                                        ],
                                        staticClass: "startPractice",
                                        on: {
                                          click: function($event) {
                                            return _vm.intoStuPreview(
                                              _vm.listItem
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("作答详情\n            ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.startTest1 === "answerDetail"
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "bury",
                                            rawName: "v-bury",
                                            value: { start: true },
                                            expression: "{start: true}"
                                          }
                                        ],
                                        staticClass: "startPractice",
                                        on: {
                                          click: function($event) {
                                            return _vm.intoStuPreview(
                                              _vm.listItem
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("作答详情\n            ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.startTest === "startQuestion"
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "bury",
                                            rawName: "v-bury",
                                            value: { start: true },
                                            expression: "{start: true}"
                                          }
                                        ],
                                        staticClass: "startPractice",
                                        on: {
                                          click: function($event) {
                                            return _vm.beginTest(_vm.listItem)
                                          }
                                        }
                                      },
                                      [_vm._v("开始作答\n            ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.startTest === "continueQuestion"
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "bury",
                                            rawName: "v-bury",
                                            value: { start: true },
                                            expression: "{start: true}"
                                          }
                                        ],
                                        staticClass: "startPractice",
                                        on: {
                                          click: function($event) {
                                            return _vm.beginTest(_vm.listItem)
                                          }
                                        }
                                      },
                                      [_vm._v("继续作答\n            ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.startTest1 === "againQuestion"
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "bury",
                                            rawName: "v-bury",
                                            value: { start: true },
                                            expression: "{start: true}"
                                          }
                                        ],
                                        staticClass: "startPractice",
                                        on: {
                                          click: function($event) {
                                            return _vm.beginTest(
                                              _vm.listItem,
                                              1
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("重做一遍\n            ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.startTest === "enter"
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "bury",
                                            rawName: "v-bury",
                                            value: { start: true },
                                            expression: "{start: true}"
                                          }
                                        ],
                                        staticClass: "startPractice",
                                        on: {
                                          click: function($event) {
                                            return _vm.intoPreview(_vm.listItem)
                                          }
                                        }
                                      },
                                      [_vm._v("进入测验\n            ")]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  : _c("div", { staticClass: "show_main_null" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../../../../static/images/wujieguo.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("本节无内容，请选择其他章节")])
                    ])
              ],
              1
            )
          : _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.statusLoading,
                    expression: "statusLoading"
                  }
                ],
                staticClass: "lock_box"
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../static/images/wujieguo.png")
                  }
                }),
                _vm._v(" "),
                !_vm.statusLoading
                  ? _c("p", [_vm._v("该章节暂未开放")])
                  : _vm._e()
              ]
            ),
        _vm._v(" "),
        (_vm.type == "3" && _vm.listItem && _vm.statusFlag && !_vm.statusLoading
        ? _vm.showFlag
        : _vm.swiperFlag)
          ? _c(
              "div",
              { staticClass: "course_right" },
              [
                _vm.isShowRight
                  ? _c("mySwiper", {
                      ref: "myswiper",
                      attrs: { type: _vm.type, catalogId: _vm.catalogId },
                      on: { getActiveIndex: _vm.getActiveIndex }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowNote
          ? _c(
              "div",
              { staticClass: "course_right" },
              [_vm.isShowNote ? _c("Note") : _vm._e()],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "study_task_statistics" }, [
      _c("p", [_vm._v("学习进度")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d36acbf8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d36acbf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/courseware/index.vue
// module id = null
// module chunks = 